import MeetupPage from '@/pages/admin/MeetupPage';
import { createFileRoute } from '@tanstack/react-router';

type MeetupSearch = {
  page?: number;
  statusGroup?: string;
  locationId?: number;
  keyword?: string;
  datePreset?: string;
  startDate?: string;
  endDate?: string;
  type?: string;
  sortBy?: string;
  sortDirection?: string;
};

export const Route = createFileRoute('/admin/meetup/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): MeetupSearch => {
    return {
      page: Number(search.page) || 1,
      statusGroup: search.statusGroup as string | undefined,
      locationId: search.locationId ? Number(search.locationId) : undefined,
      keyword: search.keyword as string | undefined,
      datePreset: search.datePreset as string | undefined,
      startDate: search.startDate as string | undefined,
      endDate: search.endDate as string | undefined,
      type: search.type as string | undefined,
      sortBy: search.sortBy as string | undefined,
      sortDirection: search.sortDirection as string | undefined,
    };
  },
});

function RouteComponent() {
  return <MeetupPage />;
}
